import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import LoadingPanel from "../components/feedback/LoadingPanel";
import { Login } from "../core/auth/components/Login";

const App = () => {
  return (
    <Suspense fallback={LoadingPanel}>
      <Outlet />
    </Suspense>
  );
};
export const publicRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
];
